import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CesiumViewer from '../views/3DViewer';
import InfrastructureManager from '../views/InfrastructureManager/';
import Contacts from '../views/InfrastructureManager/Contacts';
import AssetOverview from '../views/InfrastructureManager/AssetOverview';
import MapPortal from '../views/MapPortal';
import Home from '../views/Home';
import MyProfile from '../views/MyProfile';
import FileManager from '../views/FileManager';
import FileFullscreenPreview from '../views/FileManager/FileFullscreenPreview';
import UserManagement from '../views/UserManagement';
import ClientManager from '../views/ClientManager';
import SelectClient from '../views/SelectClient';
import { AppRoutes, AuthRoutes } from './routeConstants/appRoutes';
import MapView from '../views/MapPortal/components/MapView';
import PrintView from '../views/MapPortal/PrintView';
import AuthGuard from '../shared/components/HOC/authGuard';
import AccessGuard from '../shared/components/HOC/accessGuard';
import AssetManagerGuard from '../shared/components/HOC/assetManagerGuard';
import ClientSelectionGuard from '../shared/components/HOC/clientSelectionGuard';
import { AllowedRoles } from './routeConstants/allowedRoles';
import LoginForm from '../views/Auth/LoginForm';
import ForgotPassword from '../views/Auth/ForgotPassword';
import VerifyResetToken from '../views/Auth/ResetPassword/VerifyResetToken';
import GroupManager from '../views/GroupManager';

const Routers: React.FC = () => {
  return (
    <Routes>
      <Route path={AuthRoutes.LOGIN} element={<LoginForm />} />
      <Route path={AuthRoutes.FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={AuthRoutes.SET_PASSWORD} element={<VerifyResetToken />} />
      <Route path="/auth/reset-password" element={<Navigate to={AppRoutes.WORK_ORDERS} replace />} />
      <Route element={<AuthGuard />}>
        <Route element={<ClientSelectionGuard />}>
          <Route path="/" element={<Navigate to={AppRoutes.HOME} replace />} />
          <Route path={AppRoutes.HOME} element={<Home />} />
          <Route path="/services">
            <Route path={AppRoutes.MAP_VIEW} element={<MapView />} />
            <Route path="viewer" element={<CesiumViewer />} />
            <Route element={<AssetManagerGuard />}>
              <Route path="assetmanager/work-orders" element={<InfrastructureManager />} />
              <Route element={<AccessGuard allowedRoles={AllowedRoles.EDITOR_AND_ABOVE} />}>
                <Route path="assetmanager/contacts" element={<Contacts />} />
              </Route>
              <Route path="assetmanager/asset-overview" element={<AssetOverview />} />
            </Route>
            <Route path="map-portal" element={<MapPortal />} />
          </Route>
          <Route path="/files">
            <Route path="preview/:id" element={<FileFullscreenPreview />} />
            <Route path="shapefile/:id" element={<FileFullscreenPreview />} />
            <Route element={<AccessGuard allowedRoles={AllowedRoles.EDITOR_AND_ABOVE} />}>
              <Route path="trash" element={<FileManager />} />
            </Route>
            <Route path="all-files" element={<FileManager />} />
            <Route path="recents" element={<FileManager />} />
          </Route>
          <Route path="/services/map-portal/:id/print" element={<PrintView />} />
          <Route element={<AccessGuard allowedRoles={AllowedRoles.ONLY_ADMINS} />}>
            <Route path={AppRoutes.USER_MANAGER} element={<UserManagement />} />
          </Route>
          <Route element={<AccessGuard allowedRoles={AllowedRoles.ONLY_ADMINS} />}>
            <Route path={AppRoutes.GROUP_MANAGER} element={<GroupManager />} />
          </Route>
        </Route>
        <Route path={AppRoutes.MY_PROFILE} element={<MyProfile />} />
        <Route element={<AccessGuard allowedRoles={AllowedRoles.ONLY_CES_ADMIN} />}>
          <Route path={AppRoutes.CLIENT_MANAGER} element={<ClientManager />} />
          <Route path={AppRoutes.SELECT_CLIENT} element={<SelectClient />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Routers;
